export interface NewsItem {
  id: string;
  title: string;
  category: string;
  date: string;
  source: string;
  summary: string;
  cover: string;
  content: string[];
}

export const news: NewsItem[] = [
  {
    id: "midnight-cinema-revival",
    title: "午夜场为何正在回归：一场属于夜猫子的观影复兴",
    category: "专题",
    date: "2026-09-28",
    source: "午夜场的电影编辑部",
    summary: "从流媒体到独立影院，午夜场正在以新的方式回到人们的生活中，成为一种独特的生活方式。",
    cover: "https://readdy.ai/api/search-image?query=empty%20art%20house%20cinema%20screening%20room%20at%20midnight%20with%20warm%20amber%20screen%20glow%20and%20empty%20seats%2C%20retro%20cinematic%20atmosphere%2C%20deep%20blue%20and%20orange%20tones&width=1200&height=675&seq=mm-news-01&orientation=landscape",
    content: [
      "曾几何时，午夜场是影院里最神秘的一个时段的代名词。它不追求票房，也不讨好人群，只为一小撮醒着的人存在。而在流媒体席卷一切之后，很多人以为午夜场会就此消失。",
      "事实恰恰相反。近两年，越来越多独立影院重新排起了午夜档，观众席上坐满了二十出头的年轻人。他们不再只是来看一部电影，而是来体验一种“只有此刻”的氛围。",
      "午夜观影的仪式感正在被重新定义：低照度的大厅、褪色的海报、散场后仍在街道上讨论剧情的陌生人。这些体验无法被算法推荐取代。",
      "对平台而言，这意味着午夜电影的推荐不再只是“找一部能看的片子”，而是要帮用户找到“适合此刻情绪的那一部”。这也是我们做这个网站的原因。",
    ],
  },
  {
    id: "deep-blue-night-review",
    title: "《深蓝夜航》影评：把恐惧藏进仪表盘的微光里",
    category: "影评",
    date: "2026-09-22",
    source: "夜航评论",
    summary: "陆川野用一部“单空间”惊悚片证明，最好的悬念从不需要复杂的场景。",
    cover: "https://readdy.ai/api/search-image?query=airplane%20cockpit%20at%20night%20glowing%20with%20blue%20instruments%2C%20view%20over%20dark%20ocean%2C%20cinematic%20thriller%20mood%2C%20moody%20deep%20blue%20lighting%2C%20film%20review%20editorial%20image&width=1200&height=675&seq=mm-news-02&orientation=landscape",
    content: [
      "《深蓝夜航》几乎全部发生在一架飞机的驾驶舱里，却拍出了比多数大场面惊悚片更强的压迫感。它的秘密在于：把所有的恐惧，都交给了那层无法关闭的蓝色屏幕光。",
      "影片前四十分钟近乎平静，机长与乘客之间的对话甚至带着一点日常的松弛。正是这种松弛，让后面每一次仪表的轻微偏移都变得致命。",
      "导演陆川野没有依赖吓人的音效，而是让沉默本身成为威胁。当那层蓝光照亮人物脸上细微的动摇时，观众会突然意识到，真正偏航的从来不是飞机。",
      "结尾的处理克制而有力，把一个悬疑故事收束成了关于选择的寓言。这是今年午夜档最值得一看的作品之一。",
    ],
  },
  {
    id: "horror-sound-design",
    title: "当代恐怖片的“声音革命”：为什么安静比尖叫更吓人",
    category: "专题",
    date: "2026-09-15",
    source: "声场研究所",
    summary: "从《午夜频率》到《暗巷回声》，新一代恐怖片正把恐怖的核心交给声音设计。",
    cover: "https://readdy.ai/api/search-image?query=old%20analog%20radio%20equipment%20and%20microphones%20in%20a%20dark%20studio%2C%20warm%20orange%20indicator%20lights%2C%20moody%20sound%20design%20atmosphere%2C%20cinematic%20editorial&width=1200&height=675&seq=mm-news-03&orientation=landscape",
    content: [
      "过去十年，恐怖片最大的变化或许不在画面上，而在耳朵里。越来越多的导演发现，观众对“安静”的恐惧，远胜于对突如其来的尖叫。",
      "《午夜频率》里，最可怕的一刻发生在环境声全部消失的瞬间；《暗巷回声》则干脆让一条巷子学会用主角的声音说话。声音成了恐怖的主体。",
      "这种转向背后，是耳机与家庭影院普及带来的观影方式改变。当观众独处于黑暗时，声音的侵入感会被放大数倍。",
      "对创作者来说，这既是机会也是挑战：如何在不依赖视觉冲击的前提下，用声音构建持续的张力，仍是午夜恐怖片的核心命题。",
    ],
  },
  {
    id: "moonlight-diner-interview",
    title: "专访《月光餐馆》导演中村凛：一顿饭能讲完一场告别",
    category: "访谈",
    date: "2026-09-08",
    source: "光影对话",
    summary: "中村凛谈深夜、食物与那些没能说出口的话。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20late%20night%20diner%20counter%20with%20a%20steaming%20bowl%20of%20food%20and%20warm%20amber%20lamp%2C%20gentle%20melancholic%20mood%2C%20shallow%20depth%20of%20field%20interview%20editorial&width=1200&height=675&seq=mm-news-04&orientation=landscape",
    content: [
      "问：为什么选择“只在午夜营业的小餐馆”作为全片的唯一场景？",
      "中村凛：因为夜晚的人是最诚实的。白天的我们都在扮演角色，只有凌晨还醒着的人，才愿意把心里的话说出来。",
      "问：影片里几乎没有激烈的冲突，你如何让观众一直看下去？",
      "中村凛：靠温度。观众不是被情节推着走的，而是被那碗面的热气留住的。当他们开始关心锅里煮的是什么，故事就已经成功了。",
      "问：你希望观众看完之后做什么？",
      "中村凛：给某个人发条消息吧。哪怕只是说“我想起你了”。",
    ],
  },
  {
    id: "sleepless-city-analysis",
    title: "《无眠之城》再解读：城市的夜晚照亮了谁的愧疚",
    category: "影评",
    date: "2026-08-30",
    source: "夜行笔记",
    summary: "这部当年的口碑之作，在午夜重看时有了完全不同的重量。",
    cover: "https://readdy.ai/api/search-image?query=empty%20city%20overpass%20at%20midnight%20lit%20by%20orange%20street%20lamps%20with%20distant%20skyline%2C%20urban%20noir%20cinematic%20mood%2C%20lonely%20melancholic%20editorial%20photo&width=1200&height=675&seq=mm-news-05&orientation=landscape",
    content: [
      "第一次看《无眠之城》，很多人记住的是那个没有反转的结尾；第二次看，才会注意到整部电影其实一直在讲同一件事：人在什么时候愿意承认自己做错了。",
      "老警察陈松柏的夜巡，表面上是职业习惯，实际上是一次次无法结束的自我审判。他走过的每一条街，都是当年那桩旧案的现场。",
      "影片最动人的地方在于它拒绝给出廉价的救赎。直到最后，陈松柏也没有等到受害人家属的谅解，但他终于愿意停下脚步，认真听对方把话说完。",
      "午夜再看这部片，城市的灯光不再是背景，而是一种逼视。它照亮的不是罪恶，而是每个人心里那盏一直亮着、却不敢去关的灯。",
    ],
  },
  {
    id: "late-night-screening-guide",
    title: "一个人看午夜电影的正确姿势：从灯光到音量的一份指南",
    category: "专题",
    date: "2026-08-21",
    source: "午夜场的电影编辑部",
    summary: "想让午夜观影体验更沉浸？这六个小细节比选片更重要。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20dark%20living%20room%20at%20night%20with%20a%20glowing%20tv%20screen%2C%20warm%20ambient%20lamp%20and%20a%20blanket%2C%20cinematic%20home%20theater%20mood%2C%20deep%20blue%20interior&width=1200&height=675&seq=mm-news-06&orientation=landscape",
    content: [
      "第一，关掉所有主光源，只留一盏暖色的角落灯。屏幕的亮度应该是房间里最亮的东西，这样画面才会有“浮出来”的感觉。",
      "第二，音量比白天低两三格。午夜的环境噪音更小，过高的音量反而会削减弱音效的层次。",
      "第三，提前准备好水或热饮。午夜观影中途起身倒水，是沉浸感最大的杀手。",
      "第四，手机调成勿扰并放到够不到的地方。午夜片最擅长的就是让你在安静中走神，而通知音会瞬间毁掉一切。",
      "第五，选对片长。凌晨一点的你，可能更需要一部九十分钟的惊悚片，而不是两小时四十分钟的史诗。",
      "第六，也是最重要的：允许自己走神。午夜观影不必“看全”，有时候记住一个画面、一句台词，就已经值回票价。",
    ],
  },
  {
    id: "festival-midnight-selection",
    title: "国际影展公布午夜单元片单：六部新作入选",
    category: "新闻",
    date: "2026-08-12",
    source: "环球影讯",
    summary: "本年度影展午夜单元片单出炉，类型片依旧占据主导。",
    cover: "https://readdy.ai/api/search-image?query=film%20festival%20marquee%20lights%20at%20night%20with%20glowing%20letters%2C%20crowd%20silhouettes%2C%20cinematic%20event%20atmosphere%2C%20warm%20orange%20against%20deep%20blue%20night&width=1200&height=675&seq=mm-news-07&orientation=landscape",
    content: [
      "本年度国际影展正式公布午夜单元片单，共有六部新作入选，涵盖惊悚、恐怖、科幻与黑色幽默等多种类型。",
      "据策展方介绍，今年的选片更强调“情绪强度”而非单纯的类型标签，多部作品尝试用声音与空间营造持续的压迫感。",
      "值得注意的是，本届片单中有三部为导演长片处女作，午夜单元继续扮演着发掘新锐创作者的重要平台角色。",
      "完整片单与放映场次将于下月公布，本平台将同步跟进相关资讯与影评。",
    ],
  },
  {
    id: "how-to-pick-midnight-movie",
    title: "午夜片怎么选？按情绪而不是按类型挑片的方法",
    category: "专题",
    date: "2026-08-03",
    source: "夜行笔记",
    summary: "比起“想看恐怖片”，也许“我现在想被吓到还是被安慰”才是更好的选片标准。",
    cover: "https://readdy.ai/api/search-image?query=collection%20of%20stacked%20film%20posters%20on%20a%20dark%20wall%20lit%20by%20warm%20lamp%2C%20moody%20cinema%20corner%2C%20rich%20shadows%2C%20editorial%20atmosphere&width=1200&height=675&seq=mm-news-08&orientation=landscape",
    content: [
      "大多数人选午夜片时会先想“看什么类型”，但真正决定观影体验的，往往是你此刻的情绪。",
      "如果你刚加完班、脑子还在转——选一部节奏慢、画面温柔的作品，比如《月光餐馆》，让情绪先落地。",
      "如果你正处于精神亢奋、想被推一把——那就选《午夜频率》或《第七个夜班》，让紧张感把多余的精力烧掉。",
      "如果你想被理解，而不是被刺激——选《凌晨四点的信》或《逆光飞行》，它们不会教你什么，只是陪着你。",
      "把“此刻的情绪”放在类型前面，午夜观影的满意度会高出很多。这也是我们做相关推荐时最看重的一条原则。",
    ],
  },
  {
    id: "neon-afterimage-vfx",
    title: "《霓虹残影》幕后：一座会记忆的雨夜城市如何被建造",
    category: "新闻",
    date: "2026-07-25",
    source: "环球影讯",
    summary: "从实景雨街到数字霓虹，团队分享如何让一座城市“拥有记忆”。",
    cover: "https://readdy.ai/api/search-image?query=rainy%20neon%20city%20street%20at%20night%20with%20warm%20orange%20and%20violet%20signage%20reflected%20in%20puddles%2C%20cyberpunk%20cinematic%20behind%20the%20scenes%20atmosphere&width=1200&height=675&seq=mm-news-09&orientation=landscape",
    content: [
      "《霓虹残影》里那座反复出现、随记忆改变的雨夜城市，是今年最具讨论度的视觉设计之一。",
      "美术团队透露，影片大部分夜景来自真实雨街的实拍，再叠加大量手工绘制的霓虹招牌，以保留那种“人手温度”的杂乱感。",
      "为了让城市显得“有记忆”，团队给每条街设计了会随剧情推进而变化的招牌文字——观众第一遍几乎不会注意，二刷时才会恍然大悟。",
      "这种藏在细节里的设计思路，也让影片成为午夜档中少见的、值得反复观看的作品。",
    ],
  },
];